import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89706156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Порядок при экспорте", -1))
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Буква колонки", -1))
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-6"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Свойство", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-9" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Поле", -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Описание поля", -1))
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заголовок колонки", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-3" }
const _hoisted_20 = {
  key: 0,
  class: "col-3"
}
const _hoisted_21 = {
  key: 1,
  class: "col-3"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Соответствует", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    height: '380px',
    onSave: _ctx.save
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_IntegerControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Порядок при экспорте...",
            hasEmptyValue: true,
            "show-clear-button": false,
            value: model.exportOrder,
            "onUpdate:value": ($event: any) => ((model.exportOrder) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Буква колонки...",
            "show-clear-button": false,
            hasEmptyValue: true,
            value: model.columnLetter,
            "onUpdate:value": ($event: any) => ((model.columnLetter) = $event)
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DxCheckBox, {
            class: "Checkbox",
            value: model.isRequired,
            "onUpdate:value": ($event: any) => ((model.isRequired) = $event),
            text: "Обязательна"
          }, null, 8, ["value", "onUpdate:value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isProperty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.featureId,
                "onUpdate:id": ($event: any) => ((model.featureId) = $event),
                desc: model.featureDescription,
                "onUpdate:desc": ($event: any) => ((model.featureDescription) = $event),
                displayDescField: "name",
                keyField: "id",
                hasEmptyValue: !_ctx.isProperty,
                validationGroup: validationGroup,
                catalogueComponentName: "catalogues/FeatureCatalogue/FeatureCatalogue"
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "hasEmptyValue", "validationGroup"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_DxSelectBox, {
            class: "ModelField-control",
            "data-source": _ctx.fields,
            "value-expr": "name",
            "display-expr": _ctx.displayExpr,
            value: _ctx.selectedField,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedField) = $event)),
            onValueChanged: _ctx.fieldChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxValidator, { "validation-group": validationGroup }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule)
                ]),
                _: 2
              }, 1032, ["validation-group"])
            ]),
            _: 2
          }, 1032, ["data-source", "display-expr", "value", "onValueChanged"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Описание поля...",
            hasEmptyValue: false,
            "show-clear-button": true,
            value: model.fieldDescription,
            "onUpdate:value": ($event: any) => ((model.fieldDescription) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Заголовок колонки...",
            "show-clear-button": true,
            hasEmptyValue: false,
            value: model.columnTitle,
            "onUpdate:value": ($event: any) => ((model.columnTitle) = $event),
            validationGroup: validationGroup
          }, null, 8, ["value", "onUpdate:value", "validationGroup"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_DxCheckBox, {
            class: "Checkbox",
            value: model.isBoolean,
            "onUpdate:value": ($event: any) => ((model.isBoolean) = $event),
            text: "Признак"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        (model.isBoolean)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_DxCheckBox, {
                class: "Checkbox",
                value: model.isBooleanTrueAnyNotEmpty,
                "onUpdate:value": ($event: any) => ((model.isBooleanTrueAnyNotEmpty) = $event),
                onValueChanged: _ctx.onIsBooleanTrueAnyNotEmptyValueChanged,
                text: "Любое не пустое"
              }, null, 8, ["value", "onUpdate:value", "onValueChanged"])
            ]))
          : _createCommentVNode("", true),
        (model.isBoolean)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Соответствует...",
                hasEmptyValue: !model.isBoolean || model.isBooleanTrueAnyNotEmpty,
                disabled: model.isBooleanTrueAnyNotEmpty,
                "show-clear-button": true,
                value: model.booleanTrueValue,
                "onUpdate:value": ($event: any) => ((model.booleanTrueValue) = $event),
                validationGroup: validationGroup
              }, null, 8, ["hasEmptyValue", "disabled", "value", "onUpdate:value", "validationGroup"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onSave"]))
}